<table class="outbound-table">
    <thead *ngIf="type === 'DEFAULT'" class="outbound-table__header">
        <tr>
            <th>Flight</th>
            <th>Dest</th>
            <th>Tail</th>
            <th>Ramp/Spot</th>
            <th>Departure</th>
            <th></th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngIf="outboundTasks && outboundTasks.length; else noOutboundMsg">
            <ng-container *ngFor="let outbound of outboundTasks">
                <tr class="outbound__summary" (click)="expandOutbound.emit(outbound)"
                    [class.expanded]="expandedOutbound === outbound">
                    <td>UPS{{ (outbound.flightNumber + "").padStart(4, '0') }}</td>
                    <td>{{ outbound.destination }}</td>
                    <td>{{ outbound.tailNumber }}</td>
                    <td>{{ outbound.parkingPosition }}</td>
                    <td>{{ outbound.scheduledDepartureTime }}</td>
                    <td>
                        <mat-icon *ngIf="outbound.catering" svgIcon="icon-catering" class="catering-icon"></mat-icon>
                        <button *ngIf="type === 'SELECTED'" mat-raised-button color="warn" type="button"
                            (click)="onUnselect(outbound); $event.stopPropagation()">Remove</button>
                        <button *ngIf="type === 'DROPOFFS'" mat-raised-button color="primary" type="button"
                            (click)="dropOffTask.emit(outbound); $event.stopPropagation()">Drop Off</button>
                    </td>
                </tr>
                <tr class="outbound__details" *ngIf="expandedOutbound === outbound">
                    <td colspan="6">
                        <section class="outbound-form__section">
                            <mat-card class="outbound-form__panel--times">
                                <mat-card-title>
                                    Flight Times
                                </mat-card-title>
                                <mat-card-content>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>TASK:</td>
                                                <td>{{ outbound.plannedEnd ? (outbound.plannedEnd | momentFormat :
                                                    'H:mm') : '--' }}</td>
                                            </tr>
                                            <tr>
                                                <td>STD:</td>
                                                <td>{{ outbound.scheduledDepartureTime || '--' }}</td>
                                            </tr>
                                            <tr>
                                                <td>ETD:</td>
                                                <td>{{ outbound.estimatedDepartureTime ||
                                                    outbound.scheduledDepartureTime || '--' }}</td>
                                            </tr>
                                            <tr>
                                                <td>OUT:</td>
                                                <td>{{ outbound.actualOutTime || '--' }}</td>
                                            </tr>
                                            <tr>
                                                <td>OFF:</td>
                                                <td>{{ outbound.actualOffTime || '--' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </mat-card-content>
                            </mat-card>
                            <mat-card class="outbound-form__panel--crew">
                                <mat-card-title>Crew</mat-card-title>
                                <mat-card-content>
                                    <table *ngIf="getCrewmembers(outbound).length; else noneMsg">
                                        <tbody>
                                            <tr *ngFor="let passenger of getCrewmembers(outbound)">
                                                <td>
                                                    <mat-button-toggle
                                                        [checked]="type === 'DROPOFFS' || passenger.selected"
                                                        (change)="toggleSelectItem(passenger)">{{
                                                        passenger.role
                                                        }}
                                                    </mat-button-toggle>
                                                </td>
                                                <td>{{ passenger | passengerNameFormat }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </mat-card-content>
                            </mat-card>
                            <mat-card class="outbound-form__panel">
                                <mat-card-title>Jump Seats</mat-card-title>
                                <mat-card-content>
                                    <table *ngIf="getJumpseaters(outbound).length ; else noneMsg">
                                        <tbody>
                                            <tr *ngFor="let jumpseater of getJumpseaters(outbound)">
                                                <td>
                                                    <mat-button-toggle
                                                        [checked]="type === 'DROPOFFS' || jumpseater.selected"
                                                        (change)="toggleSelectItem(jumpseater)">
                                                        <mat-icon svgIcon="icon-tasks"></mat-icon>
                                                    </mat-button-toggle>
                                                    <ng-template #jumpSeatTextOnly>
                                                        <mat-icon svgIcon="icon-tasks"></mat-icon>
                                                    </ng-template>
                                                </td>
                                                <td [style.color]="
                                                    jumpseater?.nonEmployeePickupWarningStatus ===
                                                    'EMPLOYEE_NOT_PICKED_UP'
                                                    ? 'red'
                                                    : jumpseater?.nonEmployeePickupWarningStatus ===
                                                        'EMPLOYEE_IN_TRANSIT'
                                                        ? 'orange'
                                                        : jumpseater?.nonEmployeePickupWarningStatus ===
                                                            'EMPLOYEE_DROPPED_OFF'
                                                        ? '#009933'
                                                        : jumpseater?.nonEmployeePickupWarningStatus ===
                                                            'N/A'
                                                            ? 'var(--jumpseater-default-color)'
                                                            : null
                                                ">
                                                    {{ jumpseater |
                                                    passengerNameFormat }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </mat-card-content>
                            </mat-card>
                            <mat-card class="outbound-form__panel">
                                <mat-card-title>Other</mat-card-title>
                                <mat-card-content>
                                    <table *ngIf="outbound.addOnDetails && outbound.addOnDetails.length; else noneMsg">
                                        <tr *ngFor="let addOnDetails of outbound.addOnDetails">
                                            <td>
                                                <mat-button-toggle
                                                    [checked]="type === 'DROPOFFS' || addOnDetails.selected"
                                                    (change)="toggleSelectItem(addOnDetails)">
                                                    <ng-container [ngSwitch]="addOnDetails.type">
                                                        <mat-icon *ngSwitchCase="'Catering'" svgIcon="icon-catering">
                                                        </mat-icon>
                                                        <mat-icon *ngSwitchCase="'Customs'" svgIcon="icon-paperwork">
                                                        </mat-icon>
                                                        <mat-icon *ngSwitchCase="'Paperwork'" svgIcon="icon-paperwork">
                                                        </mat-icon>
                                                        <mat-icon *ngSwitchCase="'JS'" svgIcon="icon-user"></mat-icon>
                                                        <mat-icon *ngSwitchCase="'FO'" svgIcon="icon-user"></mat-icon>
                                                        <mat-icon *ngSwitchCase="'CPT'" svgIcon="icon-user"></mat-icon>
                                                        <mat-icon *ngSwitchCase="'Passenger'" svgIcon="icon-user">
                                                        </mat-icon>
                                                        <mat-icon *ngSwitchDefault svgIcon="icon-tasks"></mat-icon>
                                                    </ng-container>
                                                </mat-button-toggle>
                                            </td>
                                            <td>{{ addOnDetails.name }}</td>
                                        </tr>
                                    </table>
                                </mat-card-content>
                            </mat-card>
                            <div>
                                <button *ngIf="type === 'DEFAULT'" type="button" mat-raised-button color="primary"
                                    (click)="onSelect(outbound)">Select</button>
                            </div>
                        </section>
                        <section class="outbound-form__section">
                            <div class="outbound-form__panel--notes">
                                <h2>Coordinator Notes</h2>
                                <textarea maxlength="250" [disabled]="!isCoordinator"
                                    [(ngModel)]="outbound.specialInstructions"></textarea>
                            </div>
                            <div class="outbound-form__panel--notes">
                                <h2>Driver Notes</h2>
                                <textarea maxlength="250" [(ngModel)]="outbound.driverNotes"></textarea>
                            </div>
                        </section>
                    </td>
                </tr>
            </ng-container>
        </ng-container>
        <ng-template #noOutboundMsg>
            <tr *ngIf="type === 'DEFAULT'">
                <td colspan="6" class="noOutboundMsg">No outbound flights found</td>
            </tr>
        </ng-template>
    </tbody>
</table>

<ng-template #noneMsg>
    None
</ng-template>